import React from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import Pagination from 'react-bootstrap/Pagination';
import ElementLink from '../ElementLink';
import styles from './ModulePagination.module.scss';

export const ModulePaginationPropTypes = {
  currentPage: PropTypes.number,
  totalPages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func
};

export const PageButtonPropTypes = {
  pageNumber: PropTypes.number.isRequired,
  active: PropTypes.bool.isRequired
};

const PageButton = ({ pageNumber, active, router ,buildUrl}) => (
  <Pagination.Item
    active={active}
    href={buildUrl(pageNumber)}
    data-uxa-log={`video_library_page_${pageNumber}`}
    data-uxa-interactions="click shown"
    className={active && styles.active}
    data-testid="Pagination-button">
    {pageNumber}
  </Pagination.Item >
);

const ModulePagination = ({ currentPage, totalPages, onPageChange }) => {
  const router = useRouter();

  if (!router.isReady) return null;
  const pageButtons = [];
const buildUrl = (page) => {
    const { locale, defaultLocale, query } = router;

    const localePrefix =
      locale && locale !== defaultLocale ? `/${locale}` : '';

    let queryString = '';

    if (query.categories) {
      const encodedCategories = query.categories
        .replace(/\s/g, '%20'); 

      queryString += `categories=${encodedCategories}`;
    }

    if (query.subcategories) {
      const encodedSub = query.subcategories
        .replace(/\s/g, '%20');

      queryString += queryString
        ? `&subcategories=${encodedSub}`
        : `subcategories=${encodedSub}`;
    }
     if (query.k) {
      const encodedSub = query.k
        .replace(/\s/g, '%20');

      queryString += queryString
        ? `&k=${encodedSub}`
        : `k=${encodedSub}`;
    }

    return `${localePrefix}/video-library/page/${page}${queryString ? `?${queryString}` : ''
      }`;
  };

  for (let i = 1; i <= totalPages; i++) {
    pageButtons.push(<PageButton key={i} pageNumber={i} active={i === currentPage} router={router} buildUrl={buildUrl} />);
  }
  const maxButtons = 5;
  const checkpages = totalPages > maxButtons ? maxButtons : totalPages
  const numLow = Math.min(totalPages - checkpages, Math.max(0, currentPage - 1));
  const numHigh = Math.min(currentPage + checkpages - 1, totalPages);
  
  return totalPages > 1 && !!currentPage ? (
    <div
      data-testid="Pagination"
      className={styles.pagination}
      aria-live="polite"
      role="presentation"
      aria-label="pagination navigation">
      <Pagination>
        {<Pagination.Prev disabled={currentPage === 1} href={buildUrl(currentPage-1)}
        />}
        {pageButtons.slice(numLow, numHigh)}
        {<Pagination.Next disabled={currentPage === totalPages} href={buildUrl(currentPage+1)}
        />}
      </Pagination>

      {/* Mobile only */}
      <div className={styles.loadMore}>

        <a
          href={buildUrl(currentPage - 1)}
          onClick={e => {
            if (currentPage === 1) e.preventDefault()
          }}
          className={currentPage === 1 ? styles.disabledLink : styles.activeLink}>
          <span className={styles.icon}>&lsaquo;</span>Prev
        </a>

        <a
          href={buildUrl(currentPage + 1)}
          onClick={e => {
            if (currentPage === totalPages) e.preventDefault()
          }}
          className={currentPage === totalPages ? styles.disabledLink : styles.activeLink}
        >
          Next<span className={styles.icon}>&rsaquo;</span>
        </a>
      </div>
      <div className={styles.totalpages}>{`${currentPage}/${totalPages} pages`}</div>

    </div>
  ) : <div></div>;
};

PageButton.propTypes = PageButtonPropTypes;

ModulePagination.propTypes = ModulePaginationPropTypes;
ModulePagination.defaultProps = {
  currentPage: null,
  onPageChange: null
};

export default ModulePagination;